<template>
  <v-card>
    <v-container fluid>
      <v-layout row wrap align-center justify-center fill-height>
        <v-flex xl6 lg6 md6 sm6 hidden-xs-only>
          <v-btn style="margin:0px" flat icon color="primary" @click="refresh">
            <v-icon>cached</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xl6 lg6 md6 sm6 xs12 text-lg-right>
          <v-text-field
            style="padding:0px; margin:0px"
            id="searchBox"
            single-line
            v-model="searchValue"
            @keydown.enter="enter"
            :placeholder="$t('message.search') || 'Buscar'"
            append-icon="search"
            light
            hide-details
          />
        </v-flex>
      </v-layout>
    </v-container>

    <v-divider style="margin:0px"></v-divider>

    <v-card-text style="padding-top:0px">
      <v-data-table
        flat
        :pagination.sync="pagination"
        item-key="id"
        :items="pendingItems"
        :headers="headers"
        class="v-table-list compact theme--light"
        :rows-per-page-text="$t('message.rowsByPage')"
      >
        <!-- Encabezados -->
        <template slot="headers" slot-scope="props">
          <tr class="border-buttom">
            <th
              v-for="header in props.headers"
              :key="header.value"
              :class="[
                'column sortable text-xs-left',
                pagination.descending ? 'desc' : 'asc',
                header.value === pagination.sortBy ? 'active' : ''
              ]"
              @click="changeSort(header.value)"
            >
              {{ header.text }}
              <v-icon>arrow_upward</v-icon>
            </th>
          </tr>
        </template>

        <!-- Filas -->
        <template slot="items" slot-scope="props">
          <tr :active="props.selected" @click="props.selected = !props.selected">
            <td class="text-xs-left cut-text">{{ props.item.sucursal }}</td>
            <td class="text-xs-left cut-text">{{ props.item.tipoBono }}</td>
            <td class="text-xs-left cut-text">{{ props.item.lineaNegocio }}</td>
            <td class="text-xs-left cut-text">
              {{ props.item.anio }} / {{ props.item.mes }}
            </td>
            <td class="text-xs-left cut-text">{{ props.item.categoriaAps }}</td>
            <td class="text-xs-left cut-text">{{ props.item.primaNeta | currency }}</td>
            <td class="text-xs-left cut-text">{{ props.item.trimestre }}</td>
            <td class="text-xs-left cut-text">{{ props.item.pctProfit }}%</td>
            <td class="text-xs-left cut-text">{{ props.item.bonoProfit | currency }}</td>
            <td class="text-xs-left cut-text">{{ props.item.siniestralidad }}%</td>
          </tr>
        </template>

        <template slot="no-data">
          <div>{{ $t('message.noPreliquidations') }}</div>
        </template>

        <template slot="pageText" slot-scope="props">
          {{ props.pageStart }} - {{ props.pageStop }} {{ $t('message.of') }} {{ props.itemsLength }}
        </template>
      </v-data-table>
       <v-row no-gutters class="mt-4">
        <v-col cols="12" class="considerations-box">
          <div><strong>Consideraciones:</strong></div>
          <div>
            Recuerda que los bonos son válidos por <strong>90&nbsp;días</strong> a partir de la fecha de creación.
          </div>
            <div>
          Tomar en cuenta que el indicador de siniestralidad no aplica para  <strong>GARANTÍAS.&nbsp;</strong> 
          </div>
          
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import { nzDate } from "@/common/helpers/helpers";
import { i18n } from "@/main";
import router from "@/router";

export default {
  computed: {
    ...mapGetters(["loadingBonusCategory", "bonusCategoryPending", "agency"]),
    // Asegura un array aunque el store aún no cargue
    pendingItems() {
      return Array.isArray(this.bonusCategoryPending)
        ? this.bonusCategoryPending
        : [];
    }
  },
  mounted() {
    this.$store.dispatch("getBonusCategoryPending");

  },
  data() {
    return {
      searchValue: "",
      matches: [],
      pagination: {
        sortBy: "producto",
        descending: false
      },
      selected: [],
      headers: [
        { align: "left", sortable: true, text: i18n.t("message.Agency"),          value: "sucursal",        width: "1%" },
        { align: "left", sortable: true, text: i18n.t("message.bonusType"),       value: "producto",        width: "1%" },
        { align: "left", sortable: true, text: i18n.t("message.businessLine"),    value: "lineaNegocio",    width: "1%" },
        { align: "left", sortable: true, text: i18n.t("message.yearMonth"),       value: "anio",            width: "1%" },
        { align: "left", sortable: true, text: i18n.t("message.category"),        value: "categoriaAps",    width: "1%" },
        { align: "left", sortable: true, text: i18n.t("message.primaNeta"),       value: "primaNeta",       width: "1%" },
        { align: "left", sortable: true, text: i18n.t("message.quarter"),         value: "trimestre",       width: "1%" },
        { align: "left", sortable: true, text: i18n.t("message.percentageBonus"), value: "pctProfit",       width: "1%" },
        { align: "left", sortable: true, text: i18n.t("message.valueBonus"),      value: "bonoProfit",      width: "1%" },
        { align: "left", sortable: true, text: i18n.t("message.accidentRate"),    value: "siniestralidad",  width: "1%" }
      ]
    };
  },
  methods: {
    nzDate,
    toggleAll() {
      this.selected = this.selected.length ? [] : this.pendingItems.slice();
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    viewTime(commercialTime, type) {
      if (!commercialTime) return "";
      const s = commercialTime.toString();
      return type === 0 ? s.substring(0, 4) : s.substring(4);
    },
    refresh() {
      this.$store.dispatch("getBonusCategoryPending");
    },
    enter() {
      this.$store.dispatch(
        "getBonusCategoryPending",
        this.searchValue !== "" ? this.searchValue : undefined
      );
    }
  },
  watch: {
    loadingBonusCategory(val) {
      if (val) {
        this.$root.$emit("showLoading", "Cargando información, por favor espere...");
      } else {
        this.$root.$emit("hideLoading");
      }
    },
    agency() {
      this.$store.dispatch("getBonusCategoryPending");
    }
  }
};
</script>
